import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deepParseJson } from 'deep-parse-json';
import { cloneDeep } from 'lodash';
import { useNetworkContext } from 'providers/context';
import { downloadToolkit, getToolkitData, updateToolkitData } from './services';
import { QK_TOOLKIT } from './conts';
import { ToolkitData } from './types';

export const useDownloadToolkit = () => {
	return useMutation(downloadToolkit);
};

export const useGetToolkitData = () => {
	const processData = (data: any) => {
		const res: any = {};
		data.forEach((it: any) => {
			res[it.key] = it;
		});
		return new ToolkitData(res);
	};
	const { isOnline } = useNetworkContext();
	return useQuery<any, any, ToolkitData>([QK_TOOLKIT], isOnline ? getToolkitData : () => null, {
		select: data => {
			if (!isOnline && typeof settings !== 'undefined') {
				data = cloneDeep(settings).map(it => {
					if (it.data_type === 'json') {
						it.value = deepParseJson(it.value);
					}
					return it;
				});
			}
			return processData(data);
		},
	});
};

export const useUpdateToolkitData = () => {
	const queryClient = useQueryClient();
	return useMutation<any, any, any>(async params => {
		const res = await updateToolkitData(params);
		await queryClient.invalidateQueries([QK_TOOLKIT]);
		return res;
	});
};
